"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_list_item_1 = require("@campgladiator/cgui-core.atoms.list-item");
const cgui_core_atoms_divider_1 = require("@campgladiator/cgui-core.atoms.divider");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const cgui_core_utilities_helpers_redirect_link_1 = require("@campgladiator/cgui-core.utilities.helpers.redirect-link");
const list_menu_module_scss_1 = __importDefault(require("./list-menu.module.scss"));
const ListMenu = react_1.default.forwardRef((_a, ref) => {
    var { className = "", selection = "single", size = "default", items, initialActiveIds = new Set(), theme = "core" } = _a, props = __rest(_a, ["className", "selection", "size", "items", "initialActiveIds", "theme"]);
    const [activeItemIds, setActiveItemIds] = (0, react_1.useState)(selection === "multi"
        ? initialActiveIds
        : initialActiveIds.size
            ? new Set([initialActiveIds.values().next().value])
            : initialActiveIds);
    const [scrollVisible, setScrollVisible] = (0, react_1.useState)(false);
    const handleSingleSelectMenuClick = ({ id, link }) => {
        if (link) {
            (0, cgui_core_utilities_helpers_redirect_link_1.redirectLink)(link.url, link.newTab);
        }
        else if (activeItemIds.has(id)) {
            setActiveItemIds(new Set());
        }
        else {
            const newState = new Set([id]);
            setActiveItemIds(newState);
        }
    };
    const handleMultiSelectMenuClick = (id) => {
        const newState = new Set(activeItemIds);
        activeItemIds.has(id) ? newState.delete(id) : newState.add(id);
        setActiveItemIds(newState);
    };
    const wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(() => {
        if (!wrapperRef || !wrapperRef.current)
            return;
        const resizeObserver = new ResizeObserver(() => {
            wrapperRef.current.scrollHeight > wrapperRef.current.clientHeight
                ? setScrollVisible(true)
                : setScrollVisible(false);
        });
        resizeObserver.observe(wrapperRef.current);
        return () => {
            resizeObserver.unobserve(wrapperRef.current);
        };
    }, [wrapperRef.current]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(list_menu_module_scss_1.default.listMenu, className), "data-size": size, ref: ref }, props),
        react_1.default.createElement("div", { className: list_menu_module_scss_1.default.content },
            react_1.default.createElement("div", { ref: wrapperRef, className: (0, classnames_1.default)(list_menu_module_scss_1.default.wrapper, {
                    [list_menu_module_scss_1.default.scrollVisible]: scrollVisible,
                }) }, items.map((item, index) => {
                switch (item.type) {
                    case "item":
                        return (react_1.default.createElement(cgui_core_atoms_list_item_1.ListItem, Object.assign({ className: (0, classnames_1.default)(list_menu_module_scss_1.default.listItem, {
                                [list_menu_module_scss_1.default.scrollVisible]: scrollVisible,
                            }), key: `item_${item.itemId}`, size: size, active: activeItemIds.has(item.itemId), handleActive: () => {
                                selection === "multi"
                                    ? handleMultiSelectMenuClick(item.itemId)
                                    : handleSingleSelectMenuClick(item);
                            }, theme: theme }, item)));
                    case "divider":
                        return (react_1.default.createElement(cgui_core_atoms_divider_1.Divider, { className: list_menu_module_scss_1.default.divider, key: `divider_${index}` }));
                    case "header":
                        return (react_1.default.createElement("div", { className: list_menu_module_scss_1.default.header, key: index },
                            react_1.default.createElement(cgui_core_atoms_typography_1.Label, { size: "small", className: list_menu_module_scss_1.default.label, key: `header_${index}` }, item.text)));
                }
            })))));
});
exports.default = ListMenu;
//# sourceMappingURL=list-menu.js.map